<div class="flex flex-col h-full gap-2 mx-1">
    <div class="px-4 py-6 mb-8">
        <app-main-title
            iconColor="text-custom-blue"
            iconSize="xl"
            titleSize="text-2xl"
            [icon]="['fas', ActionsEnum.STATISTICS]"
            [title]="'statistics' | transloco" />
    </div>

    <div class="flex flex-col items-center justify-center flex-1 grow">
        <fa-icon
            class="py-4 text-custom-light-blue"
            size="7x"
            [icon]="['fas', ActionsEnum.STATISTICS]" />

        <span class="text-4xl font-normal my-4">{{ title() | transloco }}</span>
        @if (subtitle()) {
            <p class="text-xl font-light">{{ subtitle() | transloco }}</p>
        }

        <app-select
            [isMultiSelect]="false"
            [options]="data()"
            [placeholder]="placeholder() | transloco"
            (optionSelected)="onSelectionChange($event)" />
    </div>
</div>
